import type {TStore} from "modules/types/store";

export const checksumsSelector = ({checksums}: TStore) => checksums;
